'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import styled, { css } from 'styled-components';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { useGeneratedId } from '../../hooks/useGeneratedId.js';
import { Flex } from '../Flex/Flex.js';
import { Label } from '../Label/Label.js';
import { Text } from '../Text/Text.js';
import { InputContainer, InputWrapper } from './Input.js';

const StyledInputGroupContainer = styled(Flex).withConfig({
  componentId: "sc-1fuk9ku-0"
})(["width:100%;", ":nth-child(1),", ":nth-child(2):last-child,", ":nth-child(3){width:100%;}", ":nth-child(1) ", "{border-top-right-radius:0;border-bottom-right-radius:0;}", ":nth-child(1) [disabled]", "{margin-right:-1px;}", ":nth-child(1) ", ":not(.is--focussed,:hover){margin-right:-1px;", "}", ":nth-child(2) ", "{border-radius:0;border-top-right-radius:0;border-bottom-right-radius:0;border-right-width:0;border-left-width:0;margin-right:-1px;}", ":nth-child(2):not(:last-child) ", ":not(.is--focussed,:hover){", "}", ":last-child ", "{border-top-left-radius:0;border-bottom-left-radius:0;margin-left:-1px;}", ":last-child [disabled]", "{border-left-width:0;margin-left:0;}", ":last-child ", ":not(.is--focussed,:hover){border-left-width:0;margin-left:0;", "}"], InputContainer, InputContainer, InputContainer, InputContainer, InputWrapper, InputContainer, InputWrapper, InputContainer, InputWrapper, ({
  theme,
  hasError
}) => hasError && css(["border-top-color:", ";border-bottom-color:", ";border-left-color:", ";"], theme.components.input.variant.default.borderColorError, theme.components.input.variant.default.borderColorError, theme.components.input.variant.default.borderColorError), InputContainer, InputWrapper, InputContainer, InputWrapper, ({
  theme,
  hasError
}) => hasError && css(["border-top-color:", ";border-bottom-color:", ";"], theme.components.input.variant.default.borderColorError, theme.components.input.variant.default.borderColorError), InputContainer, InputWrapper, InputContainer, InputWrapper, InputContainer, InputWrapper, ({
  theme,
  hasError
}) => hasError && css(["border-top-color:", ";border-bottom-color:", ";border-right-color:", ";"], theme.components.input.variant.default.borderColorError, theme.components.input.variant.default.borderColorError, theme.components.input.variant.default.borderColorError));
const ErrorText = styled(Text).withConfig({
  componentId: "sc-1fuk9ku-1"
})(["margin:", ";"], ({
  theme
}) => theme.components.input.errorTextMargin);
const InputGroup = /*#__PURE__*/withTitan(({
  label,
  labelTooltip,
  hasError,
  errorText,
  className,
  children,
  testId = 'inputGroup'
}) => {
  const errorId = useGeneratedId(undefined, 'input-group-error');
  return jsxs(Flex, {
    className: className,
    flexDirection: "column",
    children: [label && jsx(Label, {
      spaceAfter: 2,
      tooltip: labelTooltip,
      children: label
    }), jsx(StyledInputGroupContainer, {
      alignItems: "flex-end",
      hasError: hasError,
      testId: testId,
      children: children
    }), errorText && hasError && jsx(ErrorText, {
      color: "danger50",
      "data-test-id": `${testId}ErrorMessage`,
      id: errorId,
      type: "labelTiny",
      children: errorText
    })]
  });
}, {
  name: 'InputGroup',
  memo: true
});

export { InputGroup };
//# sourceMappingURL=InputGroup.js.map
